import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import './App.css';
import '@dowty/ui/base.css';
import '@dowty/legal/styles.css';
import App from './App';
import { AuthProvider } from "./context/AuthContext";
import { DesignModeProvider } from "./theme/DesignMode";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

try {
  if (!localStorage.getItem('saufdings_theme')) {
    const legacyTheme = localStorage.getItem('theme');
    if (legacyTheme === 'light' || legacyTheme === 'dark') {
      localStorage.setItem('saufdings_theme', legacyTheme);
    }
  }
} catch { /* Storage may be disabled. */ }

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DesignModeProvider>
          <App />
        </DesignModeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
